import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v32.12.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import { b as e, _ as t } from "../tslib.es6.js";
import { ckmeans as i } from "simple-statistics";
import * as s from "@arcgis/core/geometry/support/webMercatorUtils";
import * as o from "@arcgis/core/geometry/geometryEngine";
import * as n from "@arcgis/core/geometry/support/geodesicUtils";
import r from "@arcgis/core/geometry/Point";
import a from "@arcgis/core/geometry/Polyline";
import l from "@arcgis/core/geometry/Polygon";
import h from "@arcgis/core/Graphic";
import c from "@arcgis/core/renderers/UniqueValueRenderer";
import d from "@arcgis/core/symbols/SimpleFillSymbol";
import { e as u } from "../utils/map.js";
import { ay as m, aD as p, aE as g, aF as y, az as f, aG as A, aA as I, a7 as b, aH as E } from "../api/rec.js";
import "uuid";
import "lodash";
import { T as v, n as Z } from "../index.js";
import { c as S, C as L, T as R, d as D } from "../enums.js";
import { L as w, A as C } from "../utils/auto-pan.js";
import { G as _ } from "../geometry/creator.js";
import { b as G, G as P, d as z } from "../geometry/utils.js";
import { L as T } from "../label-manager.js";
import { S as M, J as N } from "../symbols.js";
import { Z as O, C as F } from "../utils/zone.js";
import { a as U } from "../zone-classification.js";
import { Z as V } from "../zone-tools-base.js";
var x, B, k, J, H, Y, W, j, q, $, K, Q, X, ee, te, ie, se, oe, ne, re, ae, le, he, ce, de, ue, me, pe, ge, ye, fe, Ae, Ie, be, Ee, ve, Ze, Se;

var Le = "AREA_ID",
    Re = "IS_INCLUDED",
    De = _objectSpread({}, m),
    we = _objectSpread({}, p),
    Ce = _objectSpread({}, g);

var _e;

!function (e) {
  e[e.ANALYSIS = 0] = "ANALYSIS", e[e.EVENT = 1] = "EVENT", e[e.RECS = 2] = "RECS";
}(_e || (_e = {}));

var ZoneTools = /*#__PURE__*/function (_V) {
  _inherits(ZoneTools, _V);

  var _super = _createSuper(ZoneTools);

  function ZoneTools(i, s) {
    var _this;

    _classCallCheck(this, ZoneTools);

    _this = _super.call(this, i, s), x.add(_assertThisInitialized(_this)), _this.areaLabels = [], B.set(_assertThisInitialized(_this), void 0), k.set(_assertThisInitialized(_this), void 0), J.set(_assertThisInitialized(_this), void 0), _this.editListeners = new w(), _this.editVerticies = [], _this.editZoneIndexMaps = [], H.set(_assertThisInitialized(_this), void 0), _this.lengthLabels = [], Y.set(_assertThisInitialized(_this), void 0), W.set(_assertThisInitialized(_this), void 0), j.set(_assertThisInitialized(_this), void 0), _this.sharedEdges = [], _this.zoneCopyFromAreaId = null, _this.isMultipleMultiPartZones = O.isMultipleMultiPartZones, _this.isPolygonRingAHole = G.isPolygonRingAHole, _this.editOptions = {
      selectedVertexSymbol: M.fromJSON(v.symbols.draw.edit.selectedVertex),
      vertexSymbol: M.fromJSON(v.symbols.draw.edit.vertex)
    }, _this.activeClassifiedLayer = _this.getLayer("ACTIVE_CLASSIFIED_ZONES_LAYER"), _this.activeLayer = _this.getLayer("ACTIVE_ZONES_LAYER"), _this.classifiedLayer = _this.getLayer("CLASSIFIED_LAYER"), _this.drawLayer = _this.getLayer("ZONES_DRAW_LAYER"), _this.copyZonesLayer = _this.getLayer("ZONES_COPY_LAYER"), _this.dataLayer = _this.getLayer("ZONES_DATA_LAYER"), _this.editLayer = _this.getLayer("ZONES_EDIT_LAYER");
    var o = M.fromJSON(v.symbols.zones.normal.withDataImage),
        n = M.fromJSON(v.symbols.zones.edit);
    e(_assertThisInitialized(_this), J, new c({
      defaultSymbol: M.fromJSON(v.symbols.zones.default),
      field: Re,
      field2: "IS_EDITING",
      field3: "IS_DATA",
      fieldDelimiter: "|",
      uniqueValueInfos: [{
        value: "0|0|0",
        symbol: M.fromJSON(v.symbols.zones.normal.noData)
      }, {
        value: "0|0|1",
        symbol: o
      }, {
        value: "0|1|0",
        symbol: n
      }, {
        value: "0|1|1",
        symbol: n
      }, {
        value: "1|0|0",
        symbol: o
      }, {
        value: "1|0|1",
        symbol: o
      }, {
        value: "1|1|0",
        symbol: n
      }, {
        value: "1|1|1",
        symbol: n
      }]
    }), "f"), e(_assertThisInitialized(_this), k, new c({
      defaultSymbol: M.fromJSON(v.symbols.zones.selectedForCopy.normal),
      field: "IS_CLASSIFIED",
      uniqueValueInfos: [{
        value: "0",
        symbol: M.fromJSON(v.symbols.zones.selectedForCopy.normal)
      }, {
        value: "1",
        symbol: M.fromJSON(v.symbols.zones.selectedForCopy.classified)
      }]
    }), "f"), _this.circleCreator = new _(_this.mapView, {
      drawLayer: _this.drawLayer,
      geometryType: S.CIRCLE,
      invalidSymbol: M.fromJSON(v.symbols.zones.create.invalid),
      symbol: M.fromJSON(v.symbols.zones.create.fill),
      onDraw: function onDraw(e) {
        return t(_assertThisInitialized(_this), x, "m", he).call(_assertThisInitialized(_this), e, S.CIRCLE);
      },
      onSegmentUpdated: function onSegmentUpdated(e) {
        return t(_assertThisInitialized(_this), x, "m", be).call(_assertThisInitialized(_this), e);
      }
    }), _this.polygonCreator = new _(_this.mapView, {
      drawLayer: _this.drawLayer,
      geometryType: S.POLYGON,
      invalidSymbol: M.fromJSON(v.symbols.zones.create.invalid),
      onDraw: function onDraw(e) {
        return t(_assertThisInitialized(_this), x, "m", he).call(_assertThisInitialized(_this), e, S.POLYGON);
      },
      onSegmentUpdated: function onSegmentUpdated(e) {
        return t(_assertThisInitialized(_this), x, "m", ve).call(_assertThisInitialized(_this), e);
      },
      nudgeOptions: {
        enabled: !0,
        segment: !0
      },
      symbol: M.fromJSON(v.symbols.zones.create.fill)
    }), _this.polylineCreator = new _(_this.mapView, {
      drawLayer: _this.drawLayer,
      geometryType: S.POLYLINE,
      onDraw: function onDraw(e) {
        return t(_assertThisInitialized(_this), x, "m", he).call(_assertThisInitialized(_this), e, S.POLYLINE);
      },
      onSegmentUpdated: function onSegmentUpdated(e) {
        return t(_assertThisInitialized(_this), x, "m", ve).call(_assertThisInitialized(_this), e);
      },
      nudgeOptions: {
        enabled: !0,
        segment: !0
      },
      symbol: M.fromJSON(v.symbols.zones.create.line)
    }), e(_assertThisInitialized(_this), j, M.fromJSON(v.symbols.draw.measure.line), "f"), _this.polygonCreator.history.on("state-added", function () {
      return _this.forceUpdate();
    }), _this.polylineCreator.history.on("state-added", function () {
      return _this.forceUpdate();
    }), _this.autoPan = new C(_this.mapView);
    return _this;
  }

  _createClass(ZoneTools, [{
    key: "activateTool",
    value: function activateTool(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;

      switch (t || this.options.onSetSharedToolsetTool(e), (t || null == e) && this.unSelectTools(!0, i), e) {
        case R.ZoneCreate:
          this.mapView.container.style.cursor = L.crosshair, this.polylineCreator.activate();
          break;

        case R.DrawCircle:
          this.mapView.container.style.cursor = L.crosshair, this.circleCreator.activate();
          break;

        case R.ZoneEdit:
          this.createMapListeners();
          break;

        case R.ZoneUnion:
          this.mapView.container.style.cursor = L.default, this.createMapListeners();
          break;

        default:
          this.mapView.container.style.cursor = L.default;
      }

      i && this.forceUpdate();
    }
  }, {
    key: "activateZone",
    value: function activateZone(e) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      if (this.clearActiveZone(), this.isInclusionSelect && !t(this, x, "m", ae).call(this)) return [];
      this.activeZone = e ? e.clone() : null;
      var s = [];

      if (this.activeZone) {
        var _e2 = t(this, x, "m", ae).call(this),
            _o = this.activeZone.attributes.AREA_ID;

        this.activeZoneHistory.setState(_o), _e2 ? s.push.apply(s, _toConsumableArray(this.resetGraphics())) : !_e2 && i && (this.activeZone.attributes.IS_CLASSIFIED ? this.activeClassifiedLayer.add(new h({
          geometry: this.activeZone.geometry,
          symbol: M.fromJSON(v.symbols.zones.active.classified)
        })) : (this.activeZone.symbol = M.fromJSON(v.symbols.zones.active.normal), this.activeLayer.add(this.activeZone)), t(this, x, "m", Ie).call(this, {
          geometries: [this.activeZone.geometry]
        }), this.forceUpdate()), this.options.onSetActiveZone(this.field.fieldGuid, _o);
      } else this.activeTool === R.ZoneEdit && (this.unSelectTools(), s.push.apply(s, _toConsumableArray(this.resetGraphics()))), this.options.onSetActiveZone(this.field.fieldGuid, null);

      return s;
    }
  }, {
    key: "addZonesFromBuffers",
    value: function addZonesFromBuffers(e) {
      var i;

      switch (this.options.onSetMapIsLoading(!0), O.isSingleMultiPartZone(this.zones) && t(this, x, "m", ye).call(this), e.source) {
        case "boundary":
          i = t(this, x, "m", $).call(this, e.distance, e.unit);
          break;

        case "feature":
        case "measure":
          if (0 === e.geometries.length) {
            var _this$options = this.options,
                _e3 = _this$options.formatMessage,
                _t = _this$options.onDisplayMessage,
                _i = _this$options.messages;

            _t(_e3(_i.bufferSourceGeometriesNull), _e3(_i.bufferErrorTitle));
          } else i = t(this, x, "m", K).call(this, e.geometries, e.distance, e.unit);

      }

      return i ? (this.onBufferAdded(i), !0) : (this.options.onSetMapIsLoading(!1), !1);
    }
  }, {
    key: "applyHistoryState",
    value: function applyHistoryState(e, t) {
      this.options.onRestoreAreaList(this.field.fieldGuid, this.getRestoreId(this.history.historyIndex), e.filter(function (e) {
        return 1 === e.attributes.IS_INCLUDED;
      })), this.zones = e, this.activeZone = this.zones.find(function (e) {
        return e.attributes.AREA_ID === t;
      }), this.options.onSetActiveZone(this.field.fieldGuid, t), this.resetGraphics(), this.forceUpdate();
    }
  }, {
    key: "callResetZones",
    value: function callResetZones(e) {
      var _this2 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var i, s;
      this.field && (t ? this.options.onResetClassifiedZones(null === (i = this.field) || void 0 === i ? void 0 : i.fieldGuid, new Map(e.map(function (e) {
        var t;
        return [e.attributes.AREA_ID, {
          shape: e.geometry,
          fieldBoundaryGuid: O.zoneIsWholeFieldZone(_this2.entireFieldZones, e) ? null === (t = _this2.field) || void 0 === t ? void 0 : t.fieldBoundaryGuid : null
        }];
      })), t) : this.options.onResetZones(null === (s = this.field) || void 0 === s ? void 0 : s.fieldGuid, new Map(e.map(function (e) {
        var t;
        return [e.attributes.AREA_ID, {
          shape: e.geometry,
          fieldBoundaryGuid: O.zoneIsWholeFieldZone(_this2.entireFieldZones, e) ? null === (t = _this2.field) || void 0 === t ? void 0 : t.fieldBoundaryGuid : null
        }];
      }))));
    }
  }, {
    key: "cancel",
    value: function cancel() {
      return this.field = null, this.fieldBoundaryGuid = null, this.entireFieldZones = [], this.recEventDetails = null, this.samplingSites = null, this.allSamplingSites = null, e(this, B, !0, "f"), this.clear();
    }
  }, {
    key: "canDeleteZone",
    value: function canDeleteZone() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.activeZone;
      return !!e && !(this.isInclusionSelect && !t(this, x, "m", ae).call(this)) && this.zones.some(function (t) {
        return t.attributes.AREA_ID !== e.attributes.AREA_ID && o.intersects(t.geometry, e.geometry);
      });
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      return this.polygonCreator.isActive() ? this.polygonCreator.history.canRedo() || this.history.canRedo() : this.polylineCreator.isActive() && this.polylineCreator.history.canRedo() || this.history.canRedo();
    }
  }, {
    key: "canUndo",
    value: function canUndo() {
      return null == this.zoneCopyFromAreaId && (this.history.canUndo() || this.activeTool === R.ZoneCreate && this.polygonCreator.isActive() && this.polygonCreator.history.canUndo() || this.polylineCreator.isActive() && this.polylineCreator.history.canUndo());
    }
  }, {
    key: "classify",
    value: function classify() {
      var _this3 = this;

      var e, i;
      var s = null === (i = (e = this.options).getCurrentDetails) || void 0 === i ? void 0 : i.call(e);

      if (s) {
        var _e4 = _toConsumableArray(t(this, x, "m", ce).call(this, s).areas.reduce(function (e, t) {
          return e.has(t.classBreak.classId) ? e.get(t.classBreak.classId).push(t.areaId) : e.set(t.classBreak.classId, [t.areaId]), e;
        }, new Map()).values()),
            _i2 = _toConsumableArray(new Map(_e4.map(function (e) {
          return [e.shift(), e];
        }))).map(function (_ref, i) {
          var _ref2 = _slicedToArray(_ref, 2),
              e = _ref2[0],
              t = _ref2[1];

          var s = _this3.zones.find(function (t) {
            return t.attributes.AREA_ID === e;
          }),
              n = [s.geometry];

          t.length && n.push.apply(n, _toConsumableArray(_this3.zones.filter(function (e) {
            return t.includes(e.attributes.AREA_ID);
          }).map(function (e) {
            return e.geometry;
          })));
          var r = o.union(n);
          return _this3.createZoneGraphic(s, r, i + 1);
        });

        this.updateZones(_i2);

        var _n = this.activeZone ? this.activeZone.attributes.AREA_ID : null;

        null != _n && (this.activeZone = this.zones.find(function (e) {
          return e.attributes.AREA_ID === _n;
        })), this.resetGraphics();
      }
    }
  }, {
    key: "clearActiveZone",
    value: function clearActiveZone() {
      this.activeClassifiedLayer.removeAll(), this.activeLayer.removeAll(), t(this, x, "m", Ie).call(this);
    }
  }, {
    key: "createMapListeners",
    value: function createMapListeners() {
      var _this4 = this;

      this.removeMapListeners(), null != this.field && (this.mapListeners.add(this.mapView.on("pointer-down", function (e) {
        var i = _this4.mapView.toMap(e);

        _this4.activeTool && !t(_this4, x, "m", ae).call(_this4) || (_this4.zones.find(function (e) {
          return e.geometry.contains(i);
        }) ? _this4.preventDoubleClick = !0 : _this4.preventDoubleClick = !1, _this4.mouseDownScreenPnt = e);
      })), this.mapListeners.add(this.mapView.on("pointer-up", function (e) {
        var i = _this4.mapView.toMap(e);

        if (_this4.disabled && null == _this4.zoneCopyFromAreaId || !_this4.mouseDownScreenPnt || _this4.activeTool && !t(_this4, x, "m", ae).call(_this4)) return;
        var s = _this4.mouseDownScreenPnt;
        _this4.mouseDownScreenPnt = null;
        var o = null;
        P.arePointsWithinTolerance(s, e, 2) && (o = _this4.zones.find(function (e) {
          return e.geometry.contains(i);
        })), null == _this4.zoneCopyFromAreaId ? _this4.activeTool !== R.ZoneUnion ? (o && O.isSingleMultiPartZone(_this4.zones) && _this4.recEventDetails && _this4.recEventDetails.isMultipartZoneAutoSplitAllowed() && (t(_this4, x, "m", ye).call(_this4), _this4.resetGraphics(), o = _this4.zones.find(function (e) {
          return e.geometry.contains(i);
        })), o && _this4.isInclusionSelect && t(_this4, x, "m", fe).call(_this4, o) && (_this4.updateZones(_this4.zones, !1, !0, !1, !0), _this4.resetGraphics()), _this4.activateZone(o)) : (_this4.isInclusionSelect && null == _this4.activeZone || null == o || !t(_this4, x, "m", Ae).call(_this4, _this4.activeZone, o)) && _this4.activateZone(o) : t(_this4, x, "m", ge).call(_this4, o);
      })));
    }
  }, {
    key: "createNewZones",
    value: function createNewZones(_ref3) {
      var _this5 = this;

      var e = _ref3.features,
          _ref3$resetFields = _ref3.resetFields,
          t = _ref3$resetFields === void 0 ? [] : _ref3$resetFields,
          i = _ref3.areaIdField;
      return e.map(function (e) {
        var _objectSpread2;

        var s = _this5.zones.find(function (t) {
          return t.attributes.AREA_ID === Number(e.attributes[i]);
        }) || _this5.zones[0],
            o = _objectSpread(_objectSpread({}, s.attributes), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, Le, Number(e.attributes[i])), _defineProperty(_objectSpread2, "PREV_AREA_ID", s.attributes.AREA_ID), _defineProperty(_objectSpread2, "CALCULATED_AREA", G.calculateArea(e.geometry)), _objectSpread2));

        return t.forEach(function (e) {
          return o[e] = "";
        }), e.attributes = o, e;
      });
    }
  }, {
    key: "createZoneGraphic",
    value: function createZoneGraphic(e, t, i) {
      var _objectSpread3;

      return new h({
        geometry: t,
        symbol: e.symbol,
        attributes: _objectSpread(_objectSpread({}, e.attributes), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, Le, i), _defineProperty(_objectSpread3, "CALCULATED_AREA", G.calculateArea(t)), _defineProperty(_objectSpread3, Re, this.isInclusionSelect ? this.allSamplingSites && !e.attributes.IS_INCLUDED ? o.intersects(t, this.allSamplingSites) ? 1 : 0 : e.attributes.IS_INCLUDED : 0), _defineProperty(_objectSpread3, "PREV_AREA_ID", e.attributes.AREA_ID), _objectSpread3))
      });
    }
  }, {
    key: "deleteActiveZone",
    value: function deleteActiveZone() {
      console.assert(this.activeZone);

      var _this$getNeighboringZ = this.getNeighboringZones(this.activeZone, !1, !1),
          _this$getNeighboringZ2 = _slicedToArray(_this$getNeighboringZ, 2),
          e = _this$getNeighboringZ2[0],
          i = _this$getNeighboringZ2[1];

      t(this, x, "m", le).call(this, e, i, !1);
    }
  }, {
    key: "emitZonesUpdate",
    value: function emitZonesUpdate() {
      var e = this.isInclusionSelect ? this.zones.filter(function (e) {
        return 1 === e.attributes.IS_INCLUDED;
      }) : this.zones;
      this.options.onUpdateZones(null, null, e, this.zones);
    }
  }, {
    key: "filterGeometriesOutsideField",
    value: function filterGeometriesOutsideField(e) {
      var _this6 = this;

      return e ? e.filter(function (e) {
        return _this6.entireFieldZones.some(function (t) {
          return !!o.intersects(e.geometry, t.geometry);
        });
      }) : e;
    }
  }, {
    key: "geometriesIntersectField",
    value: function geometriesIntersectField() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return 0 !== this.entireFieldZones.length && 0 !== e.length && o.intersects(o.union(this.entireFieldZones.map(function (e) {
        return e.geometry;
      })), o.union(e));
    }
  }, {
    key: "getEntireFieldZones",
    value: function getEntireFieldZones() {
      var _this7 = this;

      if (!this.fieldsLayer) throw new Error("Field layer undefined");
      if (!this.fieldBoundaryGuid) throw new Error("Field Boundary undefined");
      return this.fieldsLayer.getFieldBoundaryByBoundaryGuid(this.fieldBoundaryGuid).then(function (e) {
        var _attributes;

        var t = G.getCombinedBoundaries(e.map(function (e) {
          return e.shape;
        }));
        return [new h({
          geometry: t,
          attributes: (_attributes = {}, _defineProperty(_attributes, Le, 1), _defineProperty(_attributes, "CALCULATED_AREA", G.calculateArea(t)), _defineProperty(_attributes, "IS_CLASSIFIED", 0), _defineProperty(_attributes, "IS_DATA", 0), _defineProperty(_attributes, "IS_EDITING", 0), _defineProperty(_attributes, Re, _this7.isInclusionSelect ? 1 : 0), _defineProperty(_attributes, "PREV_AREA_ID", 1), _attributes)
        })];
      });
    }
  }, {
    key: "getMiddleLayers",
    value: function getMiddleLayers() {
      return [this.copyZonesLayer, this.dataLayer, this.activeClassifiedLayer, this.editLayer, this.drawLayer];
    }
  }, {
    key: "getNeighboringZones",
    value: function getNeighboringZones(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var s = t ? [] : [[], []];
      if (!e) return s;
      var n = t ? function (e, t) {
        return [].concat(_toConsumableArray(e), [t]);
      } : function (e, t) {
        return [[].concat(_toConsumableArray(e[0]), [t.attributes.AREA_ID]), [].concat(_toConsumableArray(e[1]), [t.geometry])];
      };
      return i ? this.zones.filter(function (t) {
        return o.intersects(t.geometry, e.geometry);
      }).reduce(n, s) : this.zones.filter(function (t) {
        return o.intersects(t.geometry, e.geometry) && P.getSamePoints(t.geometry, e.geometry, !0).length > 1;
      }).reduce(n, s);
    }
  }, {
    key: "getTools",
    value: function getTools() {
      return [R.ZoneCreate, R.DrawCircle, R.ZoneEdit, R.ZoneUnion];
    }
  }, {
    key: "importZones",
    value: function importZones(e) {
      var _this8 = this;

      var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var r = this.options.formatMessage,
          a = this.options.messages;

      try {
        if (!this.entireFieldZones) throw new Error(r(a.errorEntireFieldZoneUndefined));

        var _l = o.union(this.entireFieldZones.map(function (e) {
          return e.geometry;
        })),
            _h = G.calculateRawArea(_l);

        var _c,
            _d,
            _u,
            _m = new Map();

        if (s) {
          var _r = new Map();

          if (n) {
            var _t2 = e.map(function (e) {
              return e.properties[s];
            });

            _d = i(_t2, U.NATURAL_BREAKS_NUMBER_OF_CLASSES), _u = new Map(), _d.forEach(function (e, t) {
              _u.set(t, {
                lowerBound: Math.min.apply(Math, _toConsumableArray(e)),
                upperBound: Math.max.apply(Math, _toConsumableArray(e))
              });
            });
          }

          e.forEach(function (e) {
            var t = e.properties[s],
                i = n ? _d.findIndex(function (e) {
              return e.includes(t);
            }) : t,
                o = _r.get(i);

            o ? o.push(e.geometry) : _r.set(i, [e.geometry]);
          });

          var _a = new Intl.Collator(void 0, {
            numeric: !0
          }).compare,
              _l2 = new Map(_toConsumableArray(_r.entries()).sort(_a)),
              _p2 = [];

          var _iterator = _createForOfIteratorHelper(_l2),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _step$value = _slicedToArray(_step.value, 2),
                  _e5 = _step$value[0],
                  _i3 = _step$value[1];

              var _s = G.removePolygonHolesSmallerThanThreshold(o.union(_i3), .001);

              _p2.push(_s);

              var _r2 = n ? _u.get(_e5).lowerBound : t(this, x, "m", re).call(this, _e5) ? +_e5 : null,
                  _a2 = n ? _u.get(_e5).upperBound : t(this, x, "m", re).call(this, _e5) ? +_e5 : null,
                  _l3 = n ? "".concat(_r2, " - ").concat(_a2) : _e5;

              G.isPolygonASliver(_s, _h) || _m.set(_e5, {
                acreage: G.calculateArea(_s),
                label: _l3,
                lowerBound: _r2,
                upperBound: _a2
              });
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          _c = _p2;
        } else _c = e.map(function (e) {
          return e.geometry;
        });

        O.clipZones(this.entireFieldZones, _c), _c = O.mergeSlivers(_c, _c, _h);

        var _O$getResidualZone = O.getResidualZone(_l, _c, _h),
            _p = _O$getResidualZone.includeResidualAreaZone,
            _g = _O$getResidualZone.updatedZones;

        if (s) {
          if (_p) {
            var _e7 = O.mergeResidualZoneOrAddClassBreak(_m, _g);

            _m = _e7[0], _g = _e7[1];
          }

          var _e6 = "Red-Yellow-Green",
              _i4 = null == _m.keys().next().value,
              _o2 = _m.size - (_i4 ? 1 : 0);

          y({
            colorRampName: _e6,
            numberOfClasses: _o2,
            includeZeroClass: _i4
          }).then(function (e) {
            if (!e) throw new Error("Error - no results from getColorRamp");
            var i = new Map();
            var o = 1;

            var _iterator2 = _createForOfIteratorHelper(_m),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _step2$value = _slicedToArray(_step2.value, 2),
                    _n2 = _step2$value[0],
                    _r3 = _step2$value[1];

                var _a3 = new F();

                _a3.classId = o.toString(), _a3.acreage = _r3.acreage, _a3.heading = s, _a3.label = _r3.label, t(_this8, x, "m", pe).call(_this8, _a3, e, o), null !== _n2 && _r3.lowerBound && _r3.upperBound && (_a3.lowerBound = _r3.lowerBound, _a3.upperBound = _r3.upperBound), i.set(o, _a3), o++;
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            t(_this8, x, "m", se).call(_this8, _g, i);
          }).catch(function (e) {
            e.errorCodeList && e.errorCodeList.length > 0 ? e.errorCodeList.forEach(function (e) {
              _this8.options.onPushToasterMessage(r(_this8.recsEventsMessages.validationErrorMsg, {
                errCode: e
              }), D.ERROR);
            }) : _this8.options.onPushToasterMessage("Unknown error getting color ramp.", D.ERROR);
          }).finally(function () {
            _this8.options.onImportZonesComplete();
          });
        } else t(this, x, "m", se).call(this, _g);
      } catch (l) {
        this.handleError(l);
      }
    }
  }, {
    key: "loadZones",
    value: function loadZones(e) {
      var _this9 = this;

      this.options.onSetMapIsLoading(!0);
      var t = e.agEventGeneralGuid ? [De.agEventGeneralGuid, De.eventAreaGuid] : [we.recGeneralGuid, we.recAreaGuid],
          i = e.agEventGeneralGuid ? De.eventAreaID : we.recAreaID;
      (e.agEventGeneralGuid ? f([e.agEventGeneralGuid], []) : A([e.recGeneralGuid])).then(function (e) {
        return e.map(I);
      }).then(function (e) {
        var s = e.map(function (e) {
          return e.geometry;
        }),
            n = o.union(_this9.entireFieldZones.map(function (e) {
          return e.geometry;
        })),
            r = G.calculateRawArea(n);
        O.clipZones(_this9.entireFieldZones, s);

        var _O$getResidualZone2 = O.getResidualZone(n, s, r),
            a = _O$getResidualZone2.updatedZones;

        return e = a.map(function (e, t) {
          var _s2;

          var s = (_s2 = {}, _defineProperty(_s2, i, t + 1), _defineProperty(_s2, "shape", e), _s2);
          return b.toFeature(s, "shape");
        }), _this9.createNewZones({
          features: e,
          resetFields: t,
          areaIdField: i
        });
      }).then(function (e) {
        _this9.callResetZones(e), _this9.setZones(e, !0, !1), _this9.unSelectTools(), _this9.activateZone(e.find(function (e) {
          return 1 === e.attributes.AREA_ID;
        }));
      }).catch(function (e) {
        return _this9.handleError(e);
      }).finally(function () {
        return _this9.options.onSetMapIsLoading(!1);
      });
    }
  }, {
    key: "openLoadZonesModal",
    value: function openLoadZonesModal() {
      this.options.onOpenLoadZonesModal(this.recEventDetails.fieldBoundaryGuid);
    }
  }, {
    key: "isSampling",
    value: function isSampling() {
      var e = this.allSamplingSites;
      return this.allSamplingSites && e.points.length > 0;
    }
  }, {
    key: "moveLayersToTop",
    value: function moveLayersToTop() {
      var _this10 = this;

      this.moveLayerToTop(this.activeLayer), this.moveLayerToTop(this.classifiedLayer), this.getMiddleLayers().forEach(function (e) {
        return _this10.moveLayerToTop(e);
      });
    }
  }, {
    key: "onBufferAdded",
    value: function onBufferAdded(e) {
      var _this11 = this;

      this.updateZones(e.map(function (e, t) {
        return _this11.createZoneGraphic(_this11.zones.find(function (t) {
          return o.contains(t.geometry, e);
        }), e, t + 1);
      })), e.newActiveId && this.activateZone(this.zones.find(function (t) {
        return t.attributes.AREA_ID === e.newActiveId;
      }));
      var t = null;
      this.activeZone && (t = this.activeZone.attributes.AREA_ID), this.reset().then(function () {
        return _this11.unSelectTools();
      }).then(function () {
        return _this11.resetGraphics();
      }).then(function () {
        t && _this11.activateZone(_this11.zones.find(function (e) {
          return e.attributes.AREA_ID === t;
        })), _this11.options.onSetMapIsLoading(!1), _this11.forceUpdate();
      });
    }
  }, {
    key: "redo",
    value: function redo() {
      var _this12 = this;

      if (!this.canRedo()) return;

      var redo = function redo() {
        _this12.unSelectTools(), _this12.isUndoRedo = !0, _this12.history.redo().then(function (e) {
          _this12.activeZoneHistory.redo().then(function (t) {
            _this12.applyHistoryState(e, t), _this12.isUndoRedo = !1;
          });
        });
      };

      if (!this.polygonCreator.isActive() && !this.polylineCreator.isActive()) return void redo();
      var e = this.polygonCreator.isActive() ? this.polygonCreator : this.polylineCreator;
      e.history.canRedo() ? e.history.redo().then(function () {
        if (e.lastMapPoint) {
          var _t3 = new PointerEvent("pointermove"),
              _this12$mapView$toScr = _this12.mapView.toScreen(e.lastMapPoint),
              _i5 = _this12$mapView$toScr.x,
              _s3 = _this12$mapView$toScr.y;

          e._updateLastPoint({
            x: _i5,
            y: _s3,
            native: _t3
          });
        }
      }) : e.deactivate().then(redo);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.activeZone = null, this.resetGraphics();
    }
  }, {
    key: "removeEditListeners",
    value: function removeEditListeners() {
      this.editListeners.removeAll();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.removeMapListeners(), this.removeEditListeners(), this.mapView.container.style.cursor = L.default, t(this, x, "m", Ie).call(this);
      var e = [];
      return this.activeTool === R.ZoneUnion && this.resetGraphics(), this.setActiveTool(null), e.push([this.polygonCreator.deactivate(), this.polylineCreator.deactivate(), this.circleCreator.deactivate()]), Promise.all(e);
    }
  }, {
    key: "resetGraphics",
    value: function resetGraphics() {
      var _this13 = this;

      this.activeClassifiedLayer.removeAll(), this.activeLayer.removeAll(), this.classifiedLayer.removeAll(), this.copyZonesLayer.removeAll(), this.dataLayer.removeAll(), this.drawLayer.removeAll(), this.editLayer.removeAll(), t(this, x, "m", Ie).call(this);
      var e = [];

      var _iterator3 = _createForOfIteratorHelper(this.zones),
          _step3;

      try {
        var _loop = function _loop() {
          var i = _step3.value;
          i.attributes.IS_EDITING = _this13.activeTool === R.ZoneEdit && _this13.activeZone && _this13.activeZone.attributes.AREA_ID === i.attributes.AREA_ID ? 1 : 0;
          var s = new h({
            geometry: i.geometry,
            attributes: i.attributes
          });

          if (e.push(s), i.attributes.IS_CLASSIFIED) {
            null == i.symbol && (i.symbol = new d({
              style: "none"
            }));

            var _e9 = G.getSimplifiedPolygonParts(i.geometry).map(function (e) {
              return new h({
                geometry: e,
                attributes: _objectSpread({}, i.attributes),
                symbol: i.symbol.clone()
              });
            });

            _this13.classifiedLayer.addMany(_e9);
          }

          t(_this13, J, "f").getUniqueValueInfo(s).then(function (e) {
            s.symbol = e ? e.symbol : t(_this13, J, "f").defaultSymbol, _this13.dataLayer.add(s);
          });
        };

        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (this.activeZone) if (this.activeTool === R.ZoneEdit) t(this, x, "m", q).call(this, {
        editZone: e.find(function (e) {
          return _this13.activeZone.attributes.AREA_ID === e.attributes.AREA_ID;
        })
      });else if (this.activeTool === R.ZoneUnion || !this.isInclusionSelect) {
        this.activeZone.attributes.IS_CLASSIFIED ? this.activeClassifiedLayer.add(new h({
          geometry: this.activeZone.geometry,
          symbol: M.fromJSON(v.symbols.zones.active.classified)
        })) : (this.activeZone.symbol = M.fromJSON(v.symbols.zones.active.normal), this.activeLayer.add(this.activeZone));

        var _e8 = this.activeTool === R.ZoneCreate ? this.dataLayer.graphics.map(function (e) {
          return e.geometry;
        }) : [this.activeZone.geometry];

        t(this, x, "m", Ie).call(this, {
          geometries: _e8
        });
      }
      return e;
    }
  }, {
    key: "setIsInclusionSelect",
    value: function setIsInclusionSelect(e) {
      this.isInclusionSelect = e;
    }
  }, {
    key: "setSamplingSites",
    value: function setSamplingSites(e) {
      this.samplingSites = "toArray" in e ? e.toArray() : e, this.allSamplingSites = this.samplingSites && this.samplingSites.length > 0 ? o.union(this.samplingSites.map(function (e) {
        return e.geometry;
      })) : null;
    }
  }, {
    key: "setToolbarMenuInset",
    value: function setToolbarMenuInset(e) {
      var t = _get(_getPrototypeOf(ZoneTools.prototype), "setToolbarMenuInset", this).call(this, e);

      return this.polylineCreator.setInsets(t), t;
    }
  }, {
    key: "setZoneCopyFromAreaId",
    value: function setZoneCopyFromAreaId(e) {
      this.zoneCopyFromAreaId = e, this.copyZonesLayer.removeAll();
    }
  }, {
    key: "setZoneData",
    value: function setZoneData(_ref4) {
      var _this14 = this;

      var i = _ref4.recEventDetails,
          s = _ref4.field;
      var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var r = arguments.length > 3 ? arguments[3] : undefined;
      this.isInclusionSelect = o, this.isAnalysisMode = n, e(this, B, !1, "f"), this.recEventDetails = i, this.field = s;
      var a = null != this.entireFieldZones && this.entireFieldZones.length > 0 && this.fieldBoundaryGuid === (i.fieldBoundaryGuid || s.fieldBoundaryGuid),
          l = t(this, x, "m", ce).call(this, i),
          c = 1 === l.areas.length && null == l.areas[0].zonePolygons,
          d = c || l.areas.length >= 1 && l.areas.every(function (e) {
        return e.zonePolygons && e.zonePolygons.every(function (e) {
          return null != e.shape;
        });
      });
      var u;
      return a || this.options.onSetToolsProcessing(!0), d || this.options.onSetMapIsLoading(!0), a ? u = Promise.resolve(this.entireFieldZones) : (this.fieldBoundaryGuid = s.fieldBoundaryGuid || i.fieldBoundaryGuid, u = this.getEntireFieldZones().then(function (e) {
        return _this14.entireFieldZones = O.cloneZones(e), e;
      }).finally(function () {
        _this14.options.onSetToolsProcessing(!1);
      })), this.clear().then(function () {
        var e;
        if (c) _this14.fieldBoundaryGuid = s.fieldBoundaryGuid, e = u.then(function (e) {
          return _this14.callResetZones(e), e;
        });else if (d) console.assert(l.areas.every(function (e) {
          return e.zonePolygons && e.zonePolygons.every(function (e) {
            return null != e.shape;
          });
        })), e = Promise.resolve(l.areas.map(function (e) {
          var i = G.getCombinedBoundaries(e.zonePolygons.map(function (e) {
            return e.shape;
          })),
              s = {
            calculatedArea: P.calculateArea(i)
          };
          return t(_this14, x, "m", me).call(_this14, new h({
            geometry: i,
            attributes: s
          }), e, []);
        }));else {
          var _i6 = l.generalGuids;

          if (l.getNewZones) {
            var _s4 = l.areas.map(function (e) {
              return e.areaGuid;
            }),
                _o3 = l.isMerge ? [] : _i6;

            e = (0, l.getNewZones)(_o3, _s4).then(function (e) {
              var i = e.map(I);
              return t(_this14, x, "m", ue).call(_this14, l, i, De.eventAreaID);
            });
          } else if (l.getAnalysisZones) {
            var _s5 = l.isMerge ? [] : _i6;

            e = (0, l.getAnalysisZones)(_s5).then(function (e) {
              var i = e.map(I);
              return t(_this14, x, "m", ue).call(_this14, l, i, Ce.analysisLayerAreaId);
            });
          } else if (l.getRecAreaZones) {
            var _s6 = l.isMerge ? [] : _i6;

            e = (0, l.getRecAreaZones)(_s6).then(function (e) {
              var i = e.map(I);
              return t(_this14, x, "m", ue).call(_this14, l, i, we.recAreaID);
            });
          }
        }
        return e = e.then(function (e) {
          t(_this14, B, "f") || (e.sort(function (e, t) {
            return parseFloat(e.attributes.AREA_ID) - parseFloat(t.attributes.AREA_ID);
          }), _this14.setZones(e, !0, !d, r), _this14.unSelectTools());
        }), Promise.all([u, e]).then(function () {
          t(_this14, B, "f") || (console.assert(1 === _this14.entireFieldZones.length), _this14.options.onSetEntireField(_this14.entireFieldZones[0].geometry));
        }).catch(function (e) {
          _this14.handleError(e);
        }).finally(function () {
          _this14.options.onSetMapIsLoading(!1);
        });
      });
    }
  }, {
    key: "setZones",
    value: function setZones(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var s = arguments.length > 3 ? arguments[3] : undefined;
      this.fieldsLayer.zoomToField(this.field.fieldGuid), this.activateZone(e.find(function (e) {
        return e.attributes.AREA_ID === (s || 1);
      }), !1), this.updateZones(e, t, i), this.resetGraphics(), this.moveLayersToTop();
    }
  }, {
    key: "splitClassifiedMultipartZones",
    value: function splitClassifiedMultipartZones() {
      var _this15 = this;

      this.updateZones(this.zones.reduce(function (e, t) {
        return e.concat(G.getSimplifiedPolygonParts(t.geometry).map(function (i, s) {
          return _this15.createZoneGraphic(t, i, e.length + s + 1);
        }));
      }, []), !1, !0, !0);
      var e = this.activeZone ? this.activeZone.attributes.AREA_ID : null;
      null != e && (this.activeZone = this.zones.find(function (t) {
        return t.attributes.AREA_ID === e;
      })), this.resetGraphics();
    }
  }, {
    key: "toggleTool",
    value: function toggleTool(e) {
      var _this16 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var i = this.activeTool;
      this.reset().then(function () {
        var s = null;

        if (e.selected) {
          switch (e.index) {
            case 0:
              s = R.ZoneCreate;
              break;

            case 1:
              s = R.DrawCircle;
              break;

            case 2:
              s = R.ZoneEdit;
              break;

            case 3:
              s = R.ZoneUnion;
          }

          _this16.moveLayersToTop();
        } else _this16.isInclusionSelect && [R.ZoneEdit, R.ZoneUnion].includes(i) && (_this16.activeZone = null), _this16.createMapListeners();

        i !== s ? _this16.initActivation({
          tool: s,
          activate: !0,
          byPassShare: !1,
          forceUpdate: t
        }, _this16.activateTool) : _this16.setActiveTool(i), t && _this16.forceUpdate();
      }).then(function () {
        return _this16.resetGraphics();
      });
    }
  }, {
    key: "undo",
    value: function undo() {
      var _this17 = this;

      if (!this.canUndo()) return;
      if (!this.polygonCreator.isActive() && !this.polylineCreator.isActive()) return this.activeTool === R.ZoneCreate ? void this.unSelectTools() : (this.isUndoRedo = !0, void this.history.undo().then(function (e) {
        _this17.activeZoneHistory.undo().then(function (t) {
          _this17.applyHistoryState(e, t), _this17.isUndoRedo = !1;
        });
      }));
      var e = this.polygonCreator.isActive() ? this.polygonCreator : this.polylineCreator;
      e.history.canUndo() ? e.history.undo().then(function () {
        if (e.lastMapPoint) {
          var _t4 = new PointerEvent("pointermove"),
              _this17$mapView$toScr = _this17.mapView.toScreen(e.lastMapPoint),
              _i7 = _this17$mapView$toScr.x,
              _s7 = _this17$mapView$toScr.y;

          e._updateLastPoint({
            x: _i7,
            y: _s7,
            native: _t4
          });
        }
      }) : (this.unSelectTools(), e.deactivate());
    }
  }, {
    key: "unSelectTools",
    value: function unSelectTools() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      [this.zoneCreate, this.zoneCircle, this.zoneEdit, this.zoneUnion].some(function (e) {
        return !!e && (e.unselect(!0), !0);
      }), this.menu && this.menu.toggleTool({
        selected: !1
      }), e ? (this.circleCreator.isActive() && this.circleCreator.deactivate(), this.polygonCreator.isActive() && this.polygonCreator.deactivate(), this.polylineCreator.isActive() && this.polylineCreator.deactivate()) : this.initActivation({
        tool: null,
        activate: !1,
        byPassShare: !1,
        forceUpdate: t
      }, this.activateTool), this.createMapListeners(), this.mapView.container.style.cursor = L.default, t && this.forceUpdate();
    }
  }, {
    key: "updateAreaHasData",
    value: function updateAreaHasData(e) {
      var _this18 = this;

      if (this.isUndoRedo) return;
      var i = !1;

      var _iterator4 = _createForOfIteratorHelper(e),
          _step4;

      try {
        var _loop2 = function _loop2() {
          var _step4$value = _slicedToArray(_step4.value, 2),
              s = _step4$value[0],
              o = _step4$value[1];

          var e = _this18.dataLayer.graphics.find(function (e) {
            return e.attributes.AREA_ID === s;
          });

          e && (e.attributes.IS_DATA = _this18.isInclusionSelect ? 0 : o ? 1 : 0, t(_this18, J, "f").getUniqueValueInfo(e).then(function (i) {
            e.symbol = i ? i.symbol : t(_this18, J, "f").defaultSymbol;
          }), i = !0);

          var n = _this18.zones.find(function (e) {
            return e.attributes.AREA_ID === s;
          });

          n && (n.attributes.IS_DATA = _this18.isInclusionSelect ? 0 : o ? 1 : 0, i = !0);
        };

        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      i && (this.history.setState(O.cloneZones(this.zones)), this.options.onSaveAreaList(this.field.fieldGuid, this.getRestoreId(this.history.historyIndex)));
    }
  }, {
    key: "updateCopyZonesFromToMap",
    value: function updateCopyZonesFromToMap(e) {
      var _this19 = this;

      if (this.copyZonesLayer.removeAll(), 0 === e.size) return;
      console.assert(1 === e.size);
      var i = e.values().next().value;

      var _iterator5 = _createForOfIteratorHelper(this.zones),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _s8 = _step5.value;

          if (i.has(_s8.attributes.AREA_ID)) {
            (function () {
              var e = new h({
                geometry: _s8.geometry,
                attributes: _s8.attributes
              });
              t(_this19, k, "f").getUniqueValueInfo(e).then(function (i) {
                e.symbol = i ? i.symbol : t(_this19, k, "f").defaultSymbol;
              }), _this19.copyZonesLayer.add(e);
            })();
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "updateZones",
    value: function updateZones(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
      var n = 0 === this.zones.length ? new Map(e.map(function (e) {
        return [e.attributes.PREV_AREA_ID, new Map()];
      })) : new Map(this.zones.map(function (e) {
        return [e.attributes.AREA_ID, new Map()];
      }));
      e.sort(function (e, t) {
        return e.attributes.AREA_ID - t.attributes.AREA_ID;
      }), this.zones = e;
      var r = O.cloneZones(this.zones),
          a = this.activeZone ? this.activeZone.attributes.AREA_ID : null;
      t && this.field && this.recEventDetails && this.options.onSaveAreaList(this.field.fieldGuid, this.getRestoreId(0)), this.history.add(r, t), this.activeZoneHistory.add(a, t);
      var l = this.isInclusionSelect ? this.zones.filter(function (e) {
        return 1 === e.attributes.IS_INCLUDED;
      }) : this.zones;

      if (i) {
        var _iterator6 = _createForOfIteratorHelper(this.zones),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _e10 = _step6.value;

            var _t5 = {
              shape: _e10.geometry,
              fieldBoundaryGuid: O.zoneIsWholeFieldZone(this.entireFieldZones, _e10) ? this.field.fieldBoundaryGuid : null
            },
                _i8 = n.get(_e10.attributes.PREV_AREA_ID);

            _i8 ? _i8.set(_e10.attributes.AREA_ID, _t5) : n.set(_e10.attributes.PREV_AREA_ID, new Map([[_e10.attributes.AREA_ID, _t5]]));
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        this.field && (this.options.onUpdateZones(this.field.fieldGuid, o ? null : n, l, this.zones.map(function (e) {
          var t = e.clone();
          return t.isIncluded = 1 === e.attributes.IS_INCLUDED, t;
        }), s), i && this.recEventDetails && this.options.onSaveAreaList(this.field.fieldGuid, this.getRestoreId(this.history.historyIndex)));
      } else this.options.onUpdateZones(null, null, l, this.zones, s);

      this.forceUpdate();
    }
  }]);

  return ZoneTools;
}(V);

B = new WeakMap(), k = new WeakMap(), J = new WeakMap(), H = new WeakMap(), Y = new WeakMap(), W = new WeakMap(), j = new WeakMap(), x = new WeakSet(), q = function q(_ref5) {
  var _this20 = this;

  var e = _ref5.editZone,
      i = _ref5.eventAreaId;
  if (this.editZone = e || this.dataLayer.graphics.find(function (e) {
    return e.attributes.AREA_ID === i;
  }), i = i || this.editZone.attributes.AREA_ID, this.editZones = this.getNeighboringZones(this.editZone, !0), this.isInclusionSelect && this.editZones.some(function (e) {
    return 0 === e.attributes.IS_INCLUDED;
  }) && (this.editZones.forEach(function (e) {
    return e.attributes.IS_INCLUDED = 1;
  }), this.updateZones(this.zones), this.resetGraphics(), this.editZones = this.getNeighboringZones(this.editZone, !0)), t(this, x, "m", ee).call(this), this.sharedEdges.length = 0, this.editZones.forEach(function (_ref6) {
    var e = _ref6.attributes,
        t = _ref6.geometry;
    e.AREA_ID !== i && _this20.sharedEdges.push(P.getSamePoints(_this20.editZone.geometry, t));
    var s = new T(_this20.drawLayer);
    s.updateLabel(P.getPolyLabelPoint(t), _this20.getAcreageText(t)), _this20.areaLabels.push(s);
  }), t(this, B, "f")) return;
  var s = this.entireFieldZones[0].geometry;
  this.entireFieldOutline = P.getPolygonOutline(s), this.editLayer.removeAll(), this.editVerticies.length = 0;

  var _iterator7 = _createForOfIteratorHelper(this.sharedEdges),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var _t6 = _step7.value;

      var _iterator9 = _createForOfIteratorHelper(_t6),
          _step9;

      try {
        var _loop3 = function _loop3() {
          var e = _step9.value;
          _this20.editVerticies.find(function (t) {
            return P.arePointsEqualish(t, e);
          }) || P.polygonHasVertex(s, e, !0) || _this20.editVerticies.push(e);
        };

        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          _loop3();
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  var _iterator8 = _createForOfIteratorHelper(this.editVerticies),
      _step8;

  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var _t7 = _step8.value;
      this.editLayer.add(new h({
        geometry: _t7,
        symbol: this.editOptions.vertexSymbol
      }));
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }

  t(this, x, "m", te).call(this), this.forceUpdate();
}, $ = function $(e, i) {
  var s = o.union(this.entireFieldZones.map(function (e) {
    return e.geometry.rings.filter(function (t) {
      return e.geometry.isClockwise(t);
    }).map(function (t) {
      return new l({
        rings: [t],
        spatialReference: e.geometry.spatialReference.clone()
      });
    });
  }).flat()),
      n = P.getExteriorRings(s),
      r = new l({
    rings: n,
    spatialReference: s.spatialReference.clone()
  }),
      h = P.getPolygonOutline(r).paths.map(function (e) {
    return new a({
      paths: [e],
      spatialReference: s.spatialReference.clone()
    });
  }),
      c = t(this, x, "m", X).call(this, h, e, i, !1);

  if (c.length) {
    var _e11 = o.union(c),
        _i9 = t(this, x, "m", oe).call(this, _e11, r, n.length > 1);

    return _i9 && t(this, x, "m", Q).call(this, _i9, c[0]), _i9;
  }
}, K = function K(e, i, s) {
  var o = t(this, x, "m", X).call(this, e, i, s);
  if (o.length) return t(this, x, "m", ne).call(this, o);
}, Q = function Q(e, t) {
  e.newActiveId = e.length, e.forEach(function (e) {
    var i = P.getPolygonOutline(e);

    if (o.intersects(i, t) && !o.intersect(i, t)) {
      var _s9 = P.getSharedPoints(o.cut(t, i));

      var _iterator10 = _createForOfIteratorHelper(_s9),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var _t8 = _step10.value;

          var _o$nearestCoordinate = o.nearestCoordinate(i, _t8),
              _s10 = _o$nearestCoordinate.coordinate;

          o.intersects(e, _s10) && (P.polygonHasVertex(e, _s10) || P.insertPointInPoly(e, _s10));
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
  });
}, X = function X(e, t, i) {
  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
  var _this$options2 = this.options,
      n = _this$options2.formatMessage,
      r = _this$options2.onDisplayMessage,
      a = _this$options2.messages,
      l = o.geodesicBuffer(e, t, i, s);
  return null == l || !1 === this.geometriesIntersectField(l) ? (r(n(a.bufferSourceGeometriesNoIntersection), n(a.bufferErrorTitle)), []) : l;
}, ee = function ee() {
  t(this, x, "m", Ie).call(this);
}, te = function te() {
  var _this21 = this;

  var i;
  this.removeEditListeners(), this.editListeners.add(this.mapView.on("pointer-move", function (t) {
    var s = {
      include: _this21.editLayer
    };

    _this21.mapView.hitTest(t, s).then(function (t) {
      t.results.length ? (e(_this21, Y, !0, "f"), _this21.mapView.container.style.cursor = L.pointer, i = t.results[0].graphic, i.symbol = _this21.editOptions.selectedVertexSymbol) : i && (e(_this21, Y, !1, "f"), _this21.mapView.container.style.cursor = L.default, i.symbol = _this21.editOptions.vertexSymbol, i = null);
    });
  })), this.editListeners.add(this.mapView.on("drag", function (e) {
    _this21.editGraphic && "update" === e.action && (_this21.editLayer, _this21.editGraphic.symbol !== _this21.editOptions.selectedVertexSymbol && (_this21.editGraphic.symbol = _this21.editOptions.selectedVertexSymbol), updateGraphics(_this21.mapView.toMap(e)), t(_this21, x, "m", Ze).call(_this21), e.stopPropagation());
  })), this.editListeners.add(this.mapView.on("pointer-down", function (e) {
    var t = {
      include: _this21.editLayer
    };

    _this21.mapView.hitTest(e, t).then(function (e) {
      if (e.results.length) {
        var _t9 = e.results[0].graphic;

        if (_this21.editGraphic = _t9, _this21.originalPoint = new r(_t9.geometry.toJSON()), _this21.editZoneIndexMaps.length = 0, _this21.editZones.forEach(function (e) {
          _this21.editZoneIndexMaps.push(P.getRingPointIndexes(e.geometry, _t9.geometry));
        }), _this21.isOnEdge = o.intersects(_this21.entireFieldOutline, _t9.geometry), _this21.isOnEdge) {
          _this21.edgeZones = _this21.editZones.filter(function (e) {
            return o.intersects(e.geometry, _t9.geometry);
          });

          var _e12 = _this21.edgeZones.map(function (e) {
            return e.geometry;
          });

          _this21.edge = P.createEdgeFromPoints(_t9.geometry, _this21.editLayer.graphics.filter(function (t) {
            return P.polygonsSharePoint(_e12, t.geometry);
          }).map(function (e) {
            return e.geometry;
          }).toArray(), _e12), _this21.originalEdges = O.cloneZones(_this21.edgeZones), _this21.edgeAreas = o.union(_e12), _this21.edgeZones.length > 2 && (_this21.edgeAreas = G.splitGeometry(_this21.edgeAreas, P.getPolylineEdgesForPoint(_this21.entireFieldOutline, _t9.geometry))), _this21.edgeAreasOutline = P.getPolygonOutline(_this21.edgeAreas), _this21.zoneSplitValid = !0;
        }

        _this21.autoPan.activate();
      }
    });
  }));
  var s = this.classifiedLayer.graphics.length > 0,
      n = [this.dataLayer];
  s && n.push(this.classifiedLayer);

  var updateGraphics = function updateGraphics(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

    var _iterator11 = _createForOfIteratorHelper(n),
        _step11;

    try {
      var _loop4 = function _loop4() {
        var i = _step11.value;
        if (_this21.isOnEdge) {
          if (t) _this21.editGraphic.geometry = _this21.originalPoint, _this21.originalEdges.forEach(function (e) {
            i.graphics.find(function (t) {
              return t.attributes.AREA_ID === e.attributes.AREA_ID;
            }).geometry = e.geometry;
          });else {
            console.assert(_this21.isOnEdge && !t);

            var _o$nearestCoordinate2 = o.nearestCoordinate(_this21.edgeAreasOutline, e),
                _s11 = _o$nearestCoordinate2.coordinate;

            _this21.editGraphic.geometry = _s11, _this21.edge && _this21.edge.setPoint(0, 0, _s11);

            var _n3 = G.splitGeometriesNow([_this21.edgeAreas], _this21.edge);

            if (_this21.zoneSplitValid = _n3 && _this21.edgeZones.length === _n3.length && !o.crosses(_this21.edge, _this21.edgeAreasOutline), _this21.zoneSplitValid) {
              (function () {
                var e = 0;

                var t = _toConsumableArray(_n3),
                    s = 2 * t.length;

                for (; t.length > 0 && e++ < s;) {
                  _this21.edgeZones.forEach(function (e) {
                    var s = i.graphics.find(function (t) {
                      return t.attributes.AREA_ID === e.attributes.AREA_ID;
                    });
                    var n = 0,
                        r = -1;

                    var _iterator12 = _createForOfIteratorHelper(t.entries()),
                        _step12;

                    try {
                      for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                        var _step12$value = _slicedToArray(_step12.value, 2),
                            _i10 = _step12$value[0],
                            _a4 = _step12$value[1];

                        _a4 && o.intersect(e.geometry, _a4) && (r = _i10, n++);
                      }
                    } catch (err) {
                      _iterator12.e(err);
                    } finally {
                      _iterator12.f();
                    }

                    1 === n && (s.geometry = t[r], t.splice(r, 1));
                  });
                }

                e >= s && (_this21.zoneSplitValid = !1);
              })();
            }

            _this21.zoneSplitValid || null == _n3 || _this21.edgeZones.forEach(function (e, t) {
              i.graphics.find(function (t) {
                return t.attributes.AREA_ID === e.attributes.AREA_ID;
              }).geometry = _n3[t];
            });
          }
        } else _this21.editGraphic.geometry = e, _this21.editZoneIndexMaps.forEach(function (t, s) {
          var o = _this21.editZones[s],
              n = i.graphics.find(function (e) {
            return e.attributes.AREA_ID === o.attributes.AREA_ID;
          });
          var r = n.geometry.clone();

          var _iterator13 = _createForOfIteratorHelper(t.entries()),
              _step13;

          try {
            for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
              var _step13$value = _slicedToArray(_step13.value, 2),
                  _i11 = _step13$value[0],
                  _a5 = _step13$value[1];

              var _iterator14 = _createForOfIteratorHelper(_a5),
                  _step14;

              try {
                for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                  var _t10 = _step14.value;
                  r = r.setPoint(_i11, _t10, e);
                }
              } catch (err) {
                _iterator14.e(err);
              } finally {
                _iterator14.f();
              }
            }
          } catch (err) {
            _iterator13.e(err);
          } finally {
            _iterator13.f();
          }

          n.geometry = o.geometry = r;
        });
      };

      for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
        _loop4();
      }
    } catch (err) {
      _iterator11.e(err);
    } finally {
      _iterator11.f();
    }
  },
      processMouseUp = function processMouseUp(e) {
    if (_this21.editGraphic) {
      if (updateGraphics(e), _this21.isOnEdge && !_this21.zoneSplitValid || _this21.editZones.some(function (e) {
        return !G.isValidPolygon(e.geometry) || !_this21.isOnEdge && e.attributes.AREA_ID !== _this21.editZone.attributes.AREA_ID && o.intersect(e.geometry, _this21.editZone.geometry);
      })) updateGraphics(_this21.originalPoint, !0), t(_this21, x, "m", Ze).call(_this21);else {
        if (_this21.isOnEdge) {
          var _iterator15 = _createForOfIteratorHelper(n),
              _step15;

          try {
            var _loop5 = function _loop5() {
              var t = _step15.value;

              var _o$nearestCoordinate3 = o.nearestCoordinate(_this21.edgeAreasOutline, e),
                  i = _o$nearestCoordinate3.coordinate;

              t.graphics.forEach(function (e) {
                o.intersects(e.geometry, i) && (P.polygonHasVertex(e.geometry, i) || P.insertPointInPoly(e.geometry, i));
              });
            };

            for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
              _loop5();
            }
          } catch (err) {
            _iterator15.e(err);
          } finally {
            _iterator15.f();
          }
        }

        var _i12 = t(_this21, x, "m", Se).call(_this21, s ? _this21.classifiedLayer.graphics.toArray() : _this21.dataLayer.graphics.toArray());

        t(_this21, x, "m", Ze).call(_this21, _i12);
      }
      _this21.isOnEdge && !t(_this21, Y, "f") && (_this21.editGraphic.symbol = _this21.editOptions.vertexSymbol), _this21.editGraphic = null, _this21.originalPoint = null, _this21.editZoneIndexMaps.length = 0, _this21.isOnEdge && (_this21.isOnEdge = !1, _this21.edgeZones.length = 0, _this21.originalEdges.length = 0, _this21.edgeAreas = null, _this21.edgeAreasOutline = null, _this21.zoneSplitValid = !0), _this21.autoPan.deactivate();
    }
  };

  this.editListeners.add(this.mapView.on("pointer-up", function (e) {
    var t = null != _this21.editGraphic;
    processMouseUp(_this21.mapView.toMap(e)), t && e.stopPropagation();
  }));
}, ie = function ie(e, t, i) {
  var _attributes2;

  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  if (null == t) return null;
  return new h({
    geometry: t,
    symbol: s || null,
    attributes: (_attributes2 = {}, _defineProperty(_attributes2, Le, i), _defineProperty(_attributes2, "CALCULATED_AREA", G.calculateArea(t)), _defineProperty(_attributes2, "IS_CLASSIFIED", s ? 1 : 0), _defineProperty(_attributes2, "IS_DATA", e ? e.attributes.IS_DATA : 0), _defineProperty(_attributes2, "IS_EDITING", 0), _defineProperty(_attributes2, Re, this.isInclusionSelect ? 1 : 0), _defineProperty(_attributes2, "PREV_AREA_ID", e ? e.attributes.AREA_ID : i), _attributes2)
  });
}, se = function se(e) {
  var _this22 = this;

  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var s = [];
  var o = this.zones && this.zones.length > 0 ? this.zones[0] : null;
  e.forEach(function (e) {
    if (e) {
      var _n4 = s.length + 1,
          _r4 = i && i.get(_n4),
          _a6 = null != _r4 ? M.fromJSON(N.createSimpleFillSymbolJSON(_r4.rgbVals)) : null;

      s.push(t(_this22, x, "m", ie).call(_this22, o, e, _n4, _a6));
    } else console.warn("Warning: Skipping null geometry from imported zones.");
  }), this.callResetZones(s, i), this.setZones(s, !0, !1), this.unSelectTools(), this.activateZone(s.find(function (e) {
    return 1 === e.attributes.AREA_ID;
  })), this.options.onImportZonesComplete();
}, oe = function oe(e, t, i) {
  var s = o.intersect(e, t),
      n = O.cloneZones(this.zones);

  if (!o.equals(s, t)) {
    if (O.zoneIsWholeFieldZone(this.entireFieldZones, this.zones[0]) && !O.polygonIntersectsHole(e, n)) {
      return (i ? G.getPolygonParts(s) : [s]).forEach(function (e) {
        n.some(function (t) {
          if (o.within(e, t.geometry)) {
            var _i13 = t.geometry.rings.findIndex(function (e) {
              return t.geometry.isClockwise(e);
            }),
                _s12 = _toConsumableArray(e.rings.find(function (t) {
              return !e.isClockwise(t);
            }));

            return t.geometry.removeRing(_i13), t.geometry.addRing(_s12.reverse()), t.geometry = o.simplify(t.geometry), n.push(new h({
              geometry: e
            })), !0;
          }

          return !1;
        });
      }), n.map(function (e) {
        return e.geometry;
      });
    }

    {
      var _e13 = new a({
        paths: s.rings.filter(function (e) {
          return !s.isClockwise(e);
        }),
        spatialReference: s.spatialReference.clone()
      });

      return G.splitGeometriesNow(n.map(function (e) {
        return e.geometry;
      }), _e13);
    }
  }

  {
    var _this$options3 = this.options,
        _e14 = _this$options3.onDisplayMessage,
        _t11 = _this$options3.formatMessage,
        _i14 = _this$options3.messages;

    _e14(_t11(_i14.bufferSourceGeometriesNoIntersection), _t11(_i14.bufferErrorTitle));
  }
}, ne = function ne(e) {
  var _this23 = this;

  var i = o.union(e);
  return P.getExteriorRings(i).map(function (e) {
    return new l({
      rings: [e],
      spatialReference: i.spatialReference.clone()
    });
  }).map(P.getPolygonOutline).reduce(function (e, i) {
    var s = P.getPolylinePoints(i),
        n = P.createPolygon(s),
        r = O.polygonIntersectsHole(n, e),
        a = s.length > 2 && O.oneZoneContainsCut(e, s);
    var l;
    return !a || r ? (l = G.splitGeometriesNow(e.map(function (e) {
      return e.geometry;
    }), i), a && r && l.reverse()) : (e.some(function (t) {
      if (o.within(n, t.geometry)) {
        var _i15 = t.geometry;
        return _i15.addRing(n.rings[0]), t.geometry = o.simplify(_i15), e.push(new h({
          geometry: n
        })), !0;
      }

      return !1;
    }), l = e.map(function (e) {
      return e.geometry;
    }), l.newActiveId = e.length), t(_this23, x, "m", Q).call(_this23, l, i), l.map(function (e) {
      return new h({
        geometry: e
      });
    });
  }, O.cloneZones(this.zones)).map(function (e) {
    return e.geometry;
  });
}, re = function re(e) {
  return !isNaN(e) && !isNaN(parseFloat(e));
}, ae = function ae() {
  return [R.ZoneEdit, R.ZoneUnion].includes(this.activeTool);
}, le = function le(e, t) {
  var _this24 = this;

  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
  var s = 0,
      n = !1;
  var r = this.isSampling() && e.includes(1);
  var a = r ? 1 : 0;
  var l = this.zones.filter(function (e) {
    return e.attributes.AREA_ID !== _this24.activeZone.attributes.AREA_ID;
  }).reduce(function (l, h) {
    var c = e.includes(h.attributes.AREA_ID);

    if (c && !n) {
      var _e15;

      r ? (_e15 = 1 === h.attributes.AREA_ID ? h : _this24.activeZone, s = 1) : (s = a + 1, _e15 = i ? _this24.activeZone : h, a++), l.push(_this24.createZoneGraphic(_e15, o.union(t), s)), n = !0;
    } else c || (l.push(_this24.createZoneGraphic(h, h.geometry, a + 1)), a++);

    return l;
  }, []);
  this.updateZones(l), this.activateZone(this.isInclusionSelect ? null : this.zones.find(function (e) {
    return e.attributes.AREA_ID === s;
  })), this.unSelectTools(), this.resetGraphics();
}, he = function he(_ref7, r) {
  var _this25 = this;

  var i = _ref7.finished,
      s = _ref7.geometry,
      n = _ref7.points;
  var a = n.length > 2 && O.oneZoneContainsCut(this.zones, n);

  if (!i && n.length > 2 && !t(this, H, "f") ? a ? this.polylineCreator.isActive() && this.polylineCreator.deactivate().then(function () {
    e(_this25, H, !0, "f"), _this25.polygonCreator.activate(n.slice(0, -1)), _this25.forceUpdate();
  }) : this.polygonCreator.isActive() && this.polygonCreator.deactivate().then(function () {
    e(_this25, H, !0, "f"), _this25.polylineCreator.activate(n.slice(0, -1)), _this25.forceUpdate();
  }) : t(this, H, "f") && e(this, H, !1, "f"), i) {
    this.options.onSetMapIsLoading(!0), O.isSingleMultiPartZone(this.zones) && t(this, x, "m", ye).call(this);
    (a ? new Promise(function (e) {
      var t = O.cloneZones(_this25.zones);
      t.some(function (e) {
        var i = P.createPolygon(n);

        if (o.within(i, e.geometry)) {
          var _s13 = e.geometry;
          return _s13.addRing(i.rings[0]), e.geometry = o.simplify(_s13), t.push(new h({
            geometry: i
          })), !0;
        }

        return !1;
      });
      var i = t.map(function (e) {
        return e.geometry;
      });
      i.newActiveId = t.length, e(i);
    }) : G.splitGeometries(this.zones.map(function (e) {
      return e.geometry;
    }), r === S.CIRCLE ? P.getPolygonOutline(s) : s)).then(function (e) {
      e.forEach(function (e) {
        var t = P.getPolygonOutline(e);

        if (o.intersects(t, s) && !o.intersect(t, s)) {
          var _i16 = P.getSharedPoints(o.cut(s, t));

          var _iterator16 = _createForOfIteratorHelper(_i16),
              _step16;

          try {
            for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
              var _s14 = _step16.value;

              var _o$nearestCoordinate4 = o.nearestCoordinate(t, _s14),
                  _i17 = _o$nearestCoordinate4.coordinate;

              o.intersects(e, _i17) && (P.polygonHasVertex(e, _i17) || P.insertPointInPoly(e, _i17));
            }
          } catch (err) {
            _iterator16.e(err);
          } finally {
            _iterator16.f();
          }
        }
      }), _this25.updateZones(e.map(function (e, t) {
        return _this25.createZoneGraphic(_this25.zones.find(function (t) {
          return o.contains(t.geometry, e);
        }), e, t + 1);
      })), e.newActiveId && _this25.activateZone(_this25.zones.find(function (t) {
        return t.attributes.AREA_ID === e.newActiveId;
      }));
    }).catch(function (e) {
      _this25.handleError(e), _this25.options.onPushToasterMessage("Error occurred while modifying geometries", D.ERROR), console.error("Error occurred while modifying geometries", e);
    }).finally(function () {
      var e = null;
      _this25.activeZone && (e = _this25.activeZone.attributes.AREA_ID), _this25.reset().then(function () {
        return _this25.unSelectTools();
      }).then(function () {
        return _this25.resetGraphics();
      }).then(function () {
        e && _this25.activateZone(_this25.zones.find(function (t) {
          return t.attributes.AREA_ID === e;
        })), _this25.options.onSetMapIsLoading(!1), _this25.forceUpdate();
      });
    });
  }
}, ce = function ce(e) {
  switch (t(this, x, "m", de).call(this, e)) {
    case _e.ANALYSIS:
      return {
        areas: e.analysisLayerAreaList.map(function (e) {
          return _objectSpread(_objectSpread({}, e), {}, {
            applyToArea: e.applyAnalysisToArea,
            areaGuid: e.analysisLayerAreaGuid,
            areaId: e.analysisLayerAreaId,
            zonePolygons: e.zonePolygons,
            classBreak: null
          });
        }),
        getAnalysisZones: E,
        guidFields: [Ce.analysisLayerGuid, Ce.analysisLayerAreaGuid],
        generalGuidField: Ce.analysisLayerGuid,
        generalGuids: e.layers.map(function (e) {
          return e.analysisLayerGuid;
        })
      };

    case _e.EVENT:
      return {
        areas: e.eventAreaList.map(function (e) {
          return _objectSpread(_objectSpread({}, e), {}, {
            applyToArea: e.applyEventToArea,
            areaGuid: e.eventAreaGuid ? e.eventAreaGuid : e.sourceEventAreaGuid,
            areaId: e.eventAreaId,
            zonePolygons: e.zonePolygons,
            classBreak: e.eventAreaClassBreak
          });
        }),
        getNewZones: f,
        guidFields: [De.agEventGeneralGuid, De.eventAreaGuid],
        generalGuidField: De.agEventGeneralGuid,
        generalGuids: [e.agEventGeneralGuid],
        isMerge: e.isMerge
      };

    case _e.RECS:
      return {
        areas: e.recAreaList.map(function (e) {
          return _objectSpread(_objectSpread({}, e), {}, {
            applyToArea: e.applyRecToArea,
            areaGuid: e.recAreaGuid,
            areaId: e.recAreaId,
            zonePolygons: e.zonePolygons,
            classBreak: e.recAreaClassBreak
          });
        }),
        getRecAreaZones: A,
        guidFields: [we.recGeneralGuid, we.recAreaGuid],
        generalGuidField: we.recGeneralGuid,
        generalGuids: [e.recGeneralGuid]
      };
  }
}, de = function de(e) {
  return null != e.eventAreaList ? _e.EVENT : e.recAreaList ? _e.RECS : _e.ANALYSIS;
}, ue = function ue(e, i, s) {
  var _this26 = this;

  return i.map(function (i) {
    var o = e.areas.find(function (e) {
      return e.areaId === i.attributes[s];
    });
    return t(_this26, x, "m", me).call(_this26, i, o, e.guidFields);
  });
}, me = function me(e, t, i) {
  var s = t.applyToArea,
      o = t.areaId,
      n = t.classBreak,
      r = s ? 1 : 0;
  return i.forEach(function (t) {
    e.attributes[t] = Z(e.attributes[t]);
  }), e.attributes.CALCULATED_AREA = e.attributes.calculatedArea || t.calculatedArea, e.attributes.AREA_ID = o, e.attributes.IS_CLASSIFIED = n ? 1 : 0, e.attributes.IS_DATA = this.isInclusionSelect ? 0 : r, e.attributes.IS_EDITING = 0, e.attributes.IS_INCLUDED = this.isInclusionSelect ? r : 0, e.attributes.PREV_AREA_ID = o, n && (e.symbol = M.fromJSON(N.createSimpleFillSymbolJSON(n.rgbVals))), e;
}, pe = function pe(e, t, i) {
  var s = t.find(function (e) {
    return e.classId === i;
  });
  e.red = s.color.r.toString(), e.green = s.color.g.toString(), e.blue = s.color.b.toString();
}, ge = function ge(e) {
  if (null == e) return;
  var t = e.attributes.AREA_ID;
  if (t === this.zoneCopyFromAreaId) return;
  var i = new Set(this.copyZonesLayer.graphics.map(function (e) {
    return e.attributes.AREA_ID;
  }));
  i.has(t) ? i.delete(t) : i.add(t), this.options.onSetCopyToAreaIdSet(i);
}, ye = function ye() {
  var _this27 = this;

  var e = this.zones[0];
  this.updateZones(G.getSimplifiedPolygonParts(e.geometry).map(function (t, i) {
    return _this27.createZoneGraphic(e, t, i + 1);
  }), !1, !0, !0);
}, fe = function fe(e) {
  if (this.activeTool === R.ZoneEdit) return !1;

  if (e.attributes.IS_INCLUDED) {
    if (1 === this.zones.reduce(function (e, t) {
      return t.attributes.IS_INCLUDED ? e + 1 : e;
    }, 0)) return !1;
    if (this.allSamplingSites && o.intersects(e.geometry, this.allSamplingSites)) return !1;
  }

  var t = 0 === e.attributes.IS_INCLUDED;
  return e.attributes.IS_INCLUDED = t ? 1 : 0, this.isAnalysisMode || this.options.onSetAreaIsIncluded(this.field.fieldGuid, e.attributes.AREA_ID, t), !0;
}, Ae = function Ae(e, i) {
  return console.assert(null != e && null != i), e.attributes.AREA_ID !== i.attributes.AREA_ID && (t(this, x, "m", le).call(this, [e.attributes.AREA_ID, i.attributes.AREA_ID], [e.geometry, i.geometry]), !0);
}, Ie = function Ie() {
  var _this28 = this;

  var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref8$geometries = _ref8.geometries,
      e = _ref8$geometries === void 0 ? [] : _ref8$geometries;

  this.areaLabels.forEach(function (e) {
    return e.clearLabel();
  }), this.areaLabels.length = 0, e.forEach(function (e) {
    if (e && e.rings[0].length > 2) {
      var _t12 = new T(_this28.drawLayer);

      _t12.updateLabel(P.getPolyLabelPoint(e), _this28.getAcreageText(e)), _this28.areaLabels.push(_t12);
    }
  });
}, be = function be(_ref9) {
  var i = _ref9.graphic;
  if (null == i) return;
  this.areaLabels.forEach(function (e) {
    return e.clearLabel();
  }), this.lengthLabels.forEach(function (e) {
    return e.clearLabel();
  }), this.areaLabels.length = this.lengthLabels.length = 0, t(this, W, "f") && this.drawLayer.remove(t(this, W, "f")), e(this, W, null, "f");
  var s = i.geometry;

  if (s && s.radius && s.center.x) {
    var _i18 = G.splitGeometriesNow(this.zones.map(function (e) {
      return e.geometry;
    }), P.getPolygonOutline(s)),
        _n5 = _i18.some(function (e) {
      return o.intersects(e, s);
    }),
        _a7 = new T(this.drawLayer);

    e(this, W, new h({
      geometry: P.createPolyline([s.center, new r({
        x: s.center.x,
        y: s.extent.ymin,
        spatialReference: s.spatialReference
      })]),
      symbol: t(this, j, "f")
    }), "f"), this.drawLayer.add(t(this, W, "f"));

    var _l4 = s.center.y - (s.center.y - s.extent.ymin) / 2;

    if (_a7.updateLabel(new r({
      x: s.center.x,
      y: _l4,
      spatialReference: s.spatialReference
    }), "".concat(this.options.formatNumber(s.radius, this.options.intlConfig.wholeNumberFormatOptions), " ft")), this.lengthLabels.push(_a7), t(this, x, "m", Ie).call(this, {
      geometries: _i18
    }), !_n5) {
      var _e16 = new T(this.drawLayer);

      _e16.updateLabel(P.getPolyLabelPoint(s), this.getAcreageText(s)), this.areaLabels.push(_e16);
    }
  }
}, Ee = function Ee(_ref10) {
  var _this29 = this;

  var _ref10$geometries = _ref10.geometries,
      e = _ref10$geometries === void 0 ? [] : _ref10$geometries,
      t = _ref10.evt;
  this.lengthLabels.forEach(function (e) {
    return e.clearLabel();
  }), this.lengthLabels.length = 0, !0 === t.native.ctrlKey && e.filter(function (e) {
    return !!e;
  }).forEach(function (e) {
    var i = e.rings || e.paths,
        o = i.length && i[i.length - 1];

    if (o && o.length > 1) {
      var _i19 = new T(_this29.drawLayer),
          _o4 = t.segment.start,
          _a8 = t.segment.end,
          _l5 = e.spatialReference.toJSON(),
          _h2 = Math.atan2(_a8.y - _o4.y, _a8.x - _o4.x) * (180 / Math.PI),
          _c2 = O.getOffset(_h2);

      var _d2;

      if (null != t.length) _d2 = z(t.length, 1);else {
        var _e17 = P.createPolyline([_o4, _a8]),
            _t13 = s.webMercatorToGeographic(_e17);

        _d2 = z(n.geodesicLengths([_t13], u[v.drawTools.lengthUnits.esriUnit.toUpperCase()])[0], 1);
      }

      _i19.resetOffset(_c2);

      _i19.labelTextSymbol.angle = _c2.angle;

      var _m2 = (_o4.x + _a8.x) / 2,
          _p3 = (_o4.y + _a8.y) / 2;

      _i19.updateLabel(new r({
        x: _m2,
        y: _p3,
        spatialReference: _l5
      }), "".concat(_d2, " ").concat(v.drawTools.lengthUnits.label)), _this29.lengthLabels.push(_i19);
    }
  });
}, ve = function ve(e) {
  if (null == e.graphic) return;
  var i = e.graphic,
      s = G.splitGeometriesNow(this.zones.map(function (e) {
    return e.geometry;
  }), "polyline" === i.geometry.type ? i.geometry : P.createPolyline(P.getPolygonPoints(i.geometry)));
  t(this, x, "m", Ie).call(this, {
    geometries: s
  }), t(this, x, "m", Ee).call(this, {
    geometries: [i.geometry],
    evt: e
  });
}, Ze = function Ze(e) {
  if (this.activeTool === R.ZoneEdit) {
    var _i20 = (e || this.dataLayer.graphics).map(function (e) {
      return e.geometry;
    });

    t(this, x, "m", Ie).call(this, {
      geometries: _i20
    });
  }
}, Se = function Se(e) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  this.zones.forEach(function (t, i) {
    var s = e.find(function (e) {
      return e.attributes.AREA_ID === t.attributes.AREA_ID;
    });
    s.attributes.PREV_AREA_ID = t.attributes.PREV_AREA_ID = t.attributes.AREA_ID, s.attributes.CALCULATED_AREA = t.attributes.CALCULATED_AREA = G.calculateArea(t.geometry);
  }), this.updateZones(e, i);
  var s = [];

  if (this.activeZone) {
    var _e18 = this.activeZone.attributes.AREA_ID;
    s.push.apply(s, _toConsumableArray(this.activateZone(this.zones.find(function (t) {
      return t.attributes.AREA_ID === _e18;
    })))), t(this, x, "m", q).call(this, {
      editZone: s.find(function (t) {
        return t.attributes.AREA_ID === _e18;
      }),
      eventAreaId: _e18
    });
  }

  return s;
};
export { _e as D, ZoneTools as Z };